<script setup lang="ts">
import { ref } from 'vue'
import { useUiStore } from '@/stores/uiStore'
import { useModal } from '@/composables/useModalStack'
import { useI18n } from '@/i18n'
import { runCommand } from '@/commands/registry'

const emit = defineEmits<{ close: [] }>()
useModal('stroke')
const { t } = useI18n()
const ui = useUiStore()
const width = ref(3)
const hex = ref(ui.foreground)
const position = ref<'inside' | 'center' | 'outside'>('center')
const opacity = ref(100)
function run() {
  if (!(width.value >= 1)) return
  void runCommand('edit.stroke', { width: width.value, hex: hex.value, position: position.value, opacity: opacity.value / 100 })
  emit('close')
}
</script>

<template>
  <div class="modal-backdrop" @pointerdown.self="emit('close')">
    <div class="modal" @keydown.esc="emit('close')" @keydown.enter="run">
      <h2>{{ t('dialog.stroke.title') }}</h2>
      <label class="field"><span>{{ t('dialog.stroke.width') }}</span><span class="row"><input v-model.number="width" type="number" min="1" max="500" autofocus /> px</span></label>
      <label class="field"><span>{{ t('dialog.fill.custom') }}</span><input v-model="hex" type="color" /></label>
      <label class="field"><span>{{ t('dialog.stroke.position') }}</span>
        <select v-model="position">
          <option value="inside">{{ t('dialog.stroke.inside') }}</option>
          <option value="center">{{ t('dialog.stroke.center') }}</option>
          <option value="outside">{{ t('dialog.stroke.outside') }}</option>
        </select>
      </label>
      <label class="field"><span>{{ t('dialog.fill.opacity') }}</span><span class="row"><input v-model.number="opacity" type="number" min="1" max="100" /> %</span></label>
      <div class="actions">
        <button @click="emit('close')">{{ t('dialog.cancel') }}</button>
        <button class="primary" @click="run">{{ t('dialog.ok') }}</button>
      </div>
    </div>
  </div>
</template>
